// Before/after drag
const ba=document.getElementById('ba');
const after=document.getElementById('baAfter');
const handle=document.getElementById('baHandle');
if(ba && after && handle){
  let dragging=false; 
  function setClip(x){
    const rect=ba.getBoundingClientRect();
    const pos=Math.max(0, Math.min(x-rect.left, rect.width));
    const pct=(pos/rect.width)*100; after.style.clipPath=`inset(0 0 0 ${pct}%)`; handle.style.left=`${pct}%`; handle.style.transform='translateX(-50%)';
  }
  handle.addEventListener('mousedown',()=> dragging=true);
  window.addEventListener('mouseup',()=> dragging=false);
  window.addEventListener('mousemove',(e)=> dragging && setClip(e.clientX));
  ba.addEventListener('touchstart',()=> dragging=true,{passive:true});
  window.addEventListener('touchend',()=> dragging=false,{passive:true});
  window.addEventListener('touchmove',(e)=> dragging && setClip(e.touches[0].clientX),{passive:true});
}
  